import {
	ADD_STATIONS,
	CITIES_LAYERS,
	DEPARTMENTS_LAYERS,
	MANAGEMENT_WATER_LAYERS,
	PANEL_CITY,
	PUT_STATIONS,
	RECEIVE_CITY_INDICATORS,
	RECEIVE_CITY_INFORMATIONS,
	RECEIVE_KEY_FIGURES,
	RECEIVE_KEY_FIGURES_SAMPLING_POINTS,
	RECEIVE_RESEARCH_TYPE,
	RECEIVE_WATERSHED_SELECTED,
	RESET_RESEARCH, RESET_STATIONS,
	SELECTED_STATIONS,
	SELECTED_TYPES,
	SET_HOVER,
	SET_OLD_VALUE,
	SET_RADIUS,
	SET_SELECTED_VALUE,
	SET_VISUALISATION,
	UPDATE_CITIES_LAYERS,
	UPDATE_MANAGEMENT_WATER_LAYERS,
	UPDATE_WATERSHED_LAYERS,
	WATERSHED_LAYERS
} from '../constants/SitesConstants'
import DtoStation from '../dto/DtoStation'
import uniqWith from 'lodash/unionWith'
import DtoKeyFigures from '../dto/DtoKeyFigures'
import DtoWatershed from '../dto/DtoWatershed'
import DtoSamplingPoint from '../dto/DtoSamplingPoint'
import DtoLayer from '../../administration/dto/DtoLayer'
import MapStyles from '../../utils/mapUtils/MapStyles'
import ApplicationConf from '../../conf/ApplicationConf'
import DtoCityIndicator from '../dto/DtoCityIndicator'
import DtoCityInformation from '../dto/DtoCityInformation'
import DtoResearchType from '../dto/DtoResearchType'
import HoverDto from '../dto/HoverDto'
import { uniqBy } from 'lodash'

export const store = {
	stations: [],
	selectedStations: [],
	visualisation: PANEL_CITY,
	selectedValue: '',
	oldValue: '',
	radius: '',
	selectedTypes: [],
	coordinates: {},
	hover: new HoverDto(),
	keyFigures: [],
	watershedSelected: [],
	watershedLayers: [],
	citiesLayers: [],
	departmentsLayers: [],
	samplingPoints: [],
	cityIndicators: [],
	cityInformations: [],
	researchTypes: [],
	managementWaterLayers: []
}

export function SitesReducer(state = {}, action) {
	switch (action.type) {
		case ADD_STATIONS: {
			/*const stations = uniqWith([].concat(action.stations.map(el => new DtoStation(el)), state.stations), (a, b) => {
				return a.id === b.id && a.typeId === b.typeId
			})*/
			const stations = [].concat(action.stations.map(el => new DtoStation(el)), state.stations)

			const selectedStations = (action.selection && action.selection.stations) ? action.selection.stations.map(s => stations.find(o => o.id === s.siteId)).filter(o => o) : stations
			return Object.assign({}, state, {
				stations: stations,
				selectedStations: selectedStations,
				coordinates: {}
			})
		}
		case PUT_STATIONS: {
			const stations = uniqWith([].concat(action.stations, state.stations), (a, b) => {
				return a.id === b.id && a.typeId == b.typeId
			})
			const selectedStations = (action.selection && action.selection.stations) ? action.selection.stations.map(s => stations.find(o => o.id === s.siteId)).filter(o => o) : stations
			return Object.assign({}, state, {
				stations: stations,
				selectedStations: selectedStations
			})
		}
		case SELECTED_STATIONS: {
			return Object.assign({}, state, {
				selectedStations: action.selectedStations,
				coordinates: {}
			})
		}
		case SET_OLD_VALUE: {
			return Object.assign({}, state, {
				oldValue: action.oldValue
			})
		}
		case SET_SELECTED_VALUE: {
			return Object.assign({}, state, {
				selectedValue: action.selectedValue
			})
		}
		case SET_RADIUS: {
			return Object.assign({}, state, {
				radius: action.radius
			})
		}
		case SET_VISUALISATION: {
			return Object.assign({}, state, {
				visualisation: action.visualisation
			})
		}
		case SELECTED_TYPES: {
			return Object.assign({}, state, {
				selectedTypes: action.selectedTypes
			})
		}
		case WATERSHED_LAYERS: {
			return Object.assign({}, state, {
				watershedLayers: uniqWith([].concat(action.watershedLayers.map(el => new DtoLayer(el, 'KML', MapStyles.FILL_BLUE)), state.watershedLayers), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case UPDATE_WATERSHED_LAYERS: {
			return Object.assign({}, state, {
				watershedLayers: action.watershedLayers
			})
		}
		case MANAGEMENT_WATER_LAYERS: {
			return Object.assign({}, state, {
				managementWaterLayers: uniqWith([].concat(action.managementWaterLayers.map(el => new DtoLayer(el, 'KML', MapStyles.FILL_BLACK)), state.managementWaterLayers), (a, b) => {
					return a.id === b.id
				})
			})
		}
		case UPDATE_MANAGEMENT_WATER_LAYERS: {
			return Object.assign({}, state, {
				managementWaterLayers: action.managementWaterLayers
			})
		}
		case CITIES_LAYERS: {
			return Object.assign({}, state, {
				citiesLayers: uniqBy([].concat(action.citiesLayers.map(el => new DtoLayer(el, 'KML', MapStyles.FILL_RED)), state.citiesLayers), 'id')
			})
		}
		case DEPARTMENTS_LAYERS: {
			return Object.assign({}, state, {
				departmentsLayers: uniqBy([].concat(action.departmentsLayers.map(el => new DtoLayer(el, 'KML', MapStyles.FILL_RED)), state.departmentsLayers), 'id')
			})
		}
		case UPDATE_CITIES_LAYERS: {
			return Object.assign({}, state, {
				citiesLayers: uniqBy([].concat(action.citiesLayers, state.citiesLayers), 'id')
			})
		}
		case RECEIVE_KEY_FIGURES: {
			return Object.assign({}, state, {
				keyFigures: uniqWith([].concat(action.keyFigures.map(el => new DtoKeyFigures(el)), state.keyFigures), (a, b) => {
					return a.id === b.id && a.typeId === b.typeId
				})
			})
		}
		case RECEIVE_KEY_FIGURES_SAMPLING_POINTS: {
			return Object.assign({}, state, {
				samplingPoints: action.samplingPoints.map(el => new DtoSamplingPoint(el))
			})
		}

		case RECEIVE_WATERSHED_SELECTED: {
			const watershed = uniqWith([].concat(action.watershedSelected.map(el => new DtoWatershed(el)), state.watershedSelected), (a, b) => {
				return a.code === b.code
			})
			const watershedLayers = uniqWith([].concat(watershed.map(el => new DtoLayer(Object.assign({}, el, {
				url: ApplicationConf.layer.whatershedLayer(el.code)
			}), 'KML', MapStyles.FILL_BLUE)), state.watershedLayers), (a, b) => {
				return a.id === b.id
			})
			return Object.assign({}, state, {
				watershedSelected: watershed,
				watershedLayers: watershedLayers
			})
		}
		case RECEIVE_CITY_INDICATORS: {
			return Object.assign({}, state, {
				cityIndicators: uniqWith([].concat(action.cityIndicators.map(el => new DtoCityIndicator(el)), state.cityIndicators), (a, b) => {
					return a.id == b.id
				})
			})
		}
		case RECEIVE_CITY_INFORMATIONS: {
			return Object.assign({}, state, {
				cityInformations: uniqWith([].concat(action.cityInformations.map(el => new DtoCityInformation(el)), state.cityInformations), (a, b) => {
					return a.code == b.code
				})
			})
		}
		case RECEIVE_RESEARCH_TYPE: {
			return Object.assign({}, state, {
				researchTypes: action.researchTypes.map(el => new DtoResearchType(el))
			})
		}
		case SET_HOVER: {
			return Object.assign({}, state, {
				hover: new HoverDto(action.hover)
			})
		}
		case RESET_RESEARCH : {
			return Object.assign({}, state, store)
		}
		case RESET_STATIONS: {
			return Object.assign({}, state, {
				stations: [],
				selectedStations: []
			})
		}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/sites/reducers/SitesReducer.js